import React from 'react'

export default function Skill({education,removeEducation,id}) {
	return (
		<>
			<li className="details-list-item"><h3><strong>{education.course}</strong></h3>
				{removeEducation && (<span className="close-icon"><button onClick={()=>removeEducation(id)}><i class="far fa-trash-alt"></i></button></span>)}
				<div>
					<p className="mb-0">({education.field}) <br/> {education.college} <br/>
					Aggregate : {education.score}%</p>
					<span className="link-style"><em>({education.start} to {education.end})</em></span>
				</div>
			</li>
		</>
	)
}